const Eye = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="15" fill="#0A3690" />
      <path
        d="M22.9401 14.7318C21.602 11.9149 18.5596 9.375 15.0005 9.375C10.9958 9.375 8.11731 12.5077 7.06091 14.7318C6.98035 14.9015 6.98035 15.0985 7.06091 15.2682C8.39893 18.0851 11.4414 20.625 15.0005 20.625C19.0051 20.625 21.8837 17.4922 22.9401 15.2682C23.0206 15.0985 23.0206 14.9015 22.9401 14.7318ZM15.0005 19.375C12.1211 19.375 9.73376 17.4774 8.33337 15C9.72791 12.5327 12.1138 10.625 15.0005 10.625C17.8796 10.625 20.2672 12.5223 21.6676 15C20.2731 17.4672 17.8872 19.375 15.0005 19.375ZM15.0005 11.875C13.2773 11.875 11.8755 13.2769 11.8755 15C11.8755 16.7231 13.2773 18.125 15.0005 18.125C16.7236 18.125 18.1255 16.7231 18.1255 15C18.1255 13.2769 16.7236 11.875 15.0005 11.875ZM15.0005 16.875C13.9667 16.875 13.1255 16.0338 13.1255 15C13.1255 13.9661 13.9667 13.125 15.0005 13.125C16.0344 13.125 16.8755 13.9661 16.8755 15C16.8755 16.0338 16.0344 16.875 15.0005 16.875Z"
        fill="white"
      />
    </svg>
  );
};

export default Eye;
